































































































































































































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {OrbitTransactionCollection} from '@/model/collection/OrbitTransactionCollection'
import {OrbitRoundRewardCollection} from '@/model/collection/OrbitRoundRewardCollection'
import {$} from '@/facade'

type TotalRewards = {
  amount: number
  symbol: string
  decimals: number
}

@Component
export default class MyWalletOrbitCards extends Vue {
  @Prop({type: Number, required: true}) activeRound!: number

  myOrbitTxs = '0'
  roundParticipations = '0'
  poolClaims = 'N/A'
  totalRewards: TotalRewards[] = []

  currentPage = 0
  itemsPerView = 2
  totalItems = 4
  currentRewardIndex = 0

  orbitProjectCollection = new OrbitProjectCollection()
  orbitRoundRewardCollection = new OrbitRoundRewardCollection()
  orbitTransactionCollection = new OrbitTransactionCollection()

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    $.await.init('populateOrbitCardValues')

    await this.populateMyOrbitTxs()
    await this.populateRoundParticipations()
    await this.populatePoolClaims()
    await this.populateTotalRewards()

    $.await.done('populateOrbitCardValues')
  }

  private async populateMyOrbitTxs() {
    const walletAddress = $.walletAdapter.n3Address
    if (!walletAddress) {
      this.myOrbitTxs = '0'
      return
    }

    this.orbitTransactionCollection.address = walletAddress

    await this.orbitTransactionCollection.queryAsPage()

    this.myOrbitTxs = String(this.orbitTransactionCollection.total)
  }

  private async populateRoundParticipations() {
    const walletAddress = $.walletAdapter.n3Address
    if (!walletAddress) {
      this.roundParticipations = '0'
      return
    }

    const roundParticipations = await this.orbitProjectCollection.countUserRoundParticipations(
      walletAddress
    )

    this.roundParticipations = String(roundParticipations)
  }

  private async populatePoolClaims() {
    const walletAddress = $.walletAdapter.n3Address
    if (!walletAddress) {
      this.poolClaims = '0'
      return
    }

    const poolClaims = await this.orbitRoundRewardCollection.countUserPoolClaims(
      walletAddress
    )

    this.poolClaims = String(poolClaims)
  }

  private async populateTotalRewards() {
    const walletAddress = $.walletAdapter.n3Address
    if (!walletAddress) {
      this.totalRewards = []
      return
    }

    const totalRewards = await this.orbitRoundRewardCollection.sumUserRewards(
      walletAddress
    )

    this.totalRewards = totalRewards || []
  }

  get currentReward() {
    return (
      this.totalRewards[this.currentRewardIndex] ?? {
        amount: 0,
        symbol: '',
        decimals: 0,
      }
    )
  }

  get totalPages() {
    return Math.max(1, Math.ceil(this.totalItems / this.itemsPerView))
  }

  changeReward(val: 'next' | 'previous') {
    const len = this.totalRewards.length
    if (len === 0) return

    if (val === 'next') {
      this.currentRewardIndex = (this.currentRewardIndex + 1) % len
      return
    }

    this.currentRewardIndex = (this.currentRewardIndex - 1 + len) % len
  }

  goPrev() {
    this.goToPage(Math.max(0, this.currentPage - 1))
  }

  goNext() {
    this.goToPage(Math.min(this.totalPages - 1, this.currentPage + 1))
  }

  goToPage(pageIndex: number) {
    this.currentPage = pageIndex
  }

  formatRewardAmount(reward: TotalRewards): string {
    if (!reward || reward.amount === 0) return '0'

    const decimals = reward.decimals || 0

    let formatted = reward.amount.toFixed(decimals)

    if (reward.amount % 1 !== 0) {
      formatted = formatted.replace(/\.?0+$/, '')
    } else {
      formatted = formatted.replace(/\.0+$/, '')
    }

    return formatted
  }

  toFullNumber(val: any): string {
    if (typeof val !== 'number') return String(val)

    if (!val.toString().includes('e')) return String(val)

    const parts = val.toString().split('e')
    let base = parts[0].replace('.', '')
    const exponent = Number(parts[1])

    if (exponent > 0) {
      return (
        base +
        '0'.repeat(exponent - (parts[0].length - parts[0].indexOf('.') - 1))
      )
    } else {
      return '0.' + '0'.repeat(Math.abs(exponent) - 1) + base
    }
  }
}
